import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import React from 'react';

export interface AppBarProps extends MuiAppBarProps {}

export const AppBar = (props: AppBarProps) => {
  return <MuiAppBar {...props} />;
};
